import { render } from "./HistoricoFases.vue?vue&type=template&id=08a785ae"
import script from "./HistoricoFases.vue?vue&type=script&lang=js"
export * from "./HistoricoFases.vue?vue&type=script&lang=js"

import "./HistoricoFases.vue?vue&type=style&index=0&id=08a785ae&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__